import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ServicesNew from './components/ServicesNew';
import EEATSection from './components/EEATSection';
import TestimonialsNew from './components/TestimonialsNew';
import AboutNew from './components/AboutNew';
import BlogSEO from './components/BlogSEO';
import FAQNew from './components/FAQNew';
import ContactNew from './components/ContactNew';
import FooterNew from './components/FooterNew';
import WhatsAppWidget from './components/WhatsAppWidget';
import { Toaster } from './components/ui/sonner';

export default function App() {
  return (
    <div className="min-h-screen bg-black overflow-x-hidden">
      <Header />
      <main className="overflow-x-hidden">
        <Hero />
        <ServicesNew />
        <EEATSection />
        <TestimonialsNew />
        <AboutNew />
        <BlogSEO />
        <FAQNew />
        <ContactNew />
      </main>
      <FooterNew />
      <WhatsAppWidget />
      <Toaster />
    </div>
  );
}
